export default "__VITE_ASSET__2b_rRO2c__"